import { render, staticRenderFns } from "./directSectionExtras.vue?vue&type=template&id=efb947a2&scoped=true"
import script from "./directSectionExtras.vue?vue&type=script&lang=js"
export * from "./directSectionExtras.vue?vue&type=script&lang=js"
import style0 from "./directSectionExtras.vue?vue&type=style&index=0&id=efb947a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb947a2",
  null
  
)

export default component.exports